import React from 'react';
import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import styled from 'styled-components/macro';
import { ButtonLink } from '../../../components/Buttons';

import { colors } from '../../../styles/constants';
import StepHeader from './StepHeader';
import StepContent from './StepContent';
import StepWrapper from './StepWrapper';

export interface ApiClientStepProps extends WithTranslation {
    current: number;
}

const step = 3;

const ApiClientStep = (
    {
        t,
        current,
    }: ApiClientStepProps
) => {
    return (
        <StepWrapper>
            <StepHeader title={t('wizards.checkout.api_client_step.title')} step={step} current={current} />
            {current === step && (
                <StepContent>
                    {t('wizards.checkout.api_client_step.description')}
                    <br />
                    <br />
                    <Trans i18nKey="wizards.checkout.api_client_step.more_info">
                        <StyledLink href="https://docs.dintero.com/docs/clients/">the documentation</StyledLink>
                    </Trans>
                    <br />
                    <br />
                    <ButtonLink to="../settings/clients/new-checkout?name=Checkout%20client&environment=production">
                        {t('wizards.checkout.api_client_step.call_to_action')}
                    </ButtonLink>
                </StepContent>
            )}
        </StepWrapper>
    );
};

const StyledLink = styled.a`
    color: ${colors.primary};

    &:hover {
        color: ${colors.primaryHover};
    }
`;

export default withTranslation()(ApiClientStep);
